<template>
  <div class="section">
    <div class="section-header"><h3>할부내역</h3></div>
    <div class="section-body">
      <dl class="field-group">
        <dt class="field-label">
          할인유형
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <!-- StringUtil.getDecimalFormat(halbuPrice, 0) -->
            <p class="data-text">{{registration.dcntKdNm}}</p>
          </div>
        </dd>
      </dl>
      <dl class="field-group"  v-if="openMarketInfo.lrpsDiscOpenYn ==='N' || (openMarketInfo.lrpsDiscOpenYn ==='Y' && openMarketInfo.dmbrYn ==='Y') ">
        <dt class="field-label">
          할부금액
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <!-- StringUtil.getDecimalFormat(halbuPrice, 0) -->
            <p class="data-text">{{ tinsAmt }}원</p>
          </div>
        </dd>
      </dl>

      <dl class="field-group" v-if="openMarketInfo.lrpsDiscOpenYn ==='N' || (openMarketInfo.lrpsDiscOpenYn ==='Y' && openMarketInfo.dmbrYn ==='Y') ">
        <dt class="field-label">
          월청구금액
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <!-- StringUtil.getDecimalFormat(String.valueOf(strMok), 0) -->
            <p class="data-text">{{ pricePerMonth }}원</p>
          </div>
        </dd>
      </dl>
      <dl class="field-group" v-if="openMarketInfo.lrpsDiscOpenYn ==='N' || (openMarketInfo.lrpsDiscOpenYn ==='Y' && openMarketInfo.dmbrYn ==='Y') ">
        <dt class="field-label">
          할부기간
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <!-- halbuMonth -->
            <p class="data-text">{{ agmtTermMmct }}개월</p>
          </div>
        </dd>
      </dl>
      <dl class="field-group" v-if="openMarketInfo.lrpsDiscOpenYn ==='N' || (openMarketInfo.lrpsDiscOpenYn ==='Y' && openMarketInfo.dmbrYn ==='Y') ">
        <dt class="field-label">
          최초청구금액
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <p class="data-text">{{ hphnInitStlmAmt }}원</p>
          </div>
        </dd>
      </dl>
      <dl class="field-group">
        <dt class="field-label">
          할부수수료
        </dt>
        <dd class="field-control">
          <ul class="notice-text-list">
            <li class="notice-text">
              연 5.9%가 원리금 균등 분할 상환 방식으로 매월 청구 됨
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <v-dialog />
  </div>
</template>

<script>
import { getItemDstrDiscount,getItemDstrDiscountNew } from '@/api/captureService'
import { common } from '~/js/common'
export default {
  name: 'InstallmentSectionView',

  computed: {},

  props: {
    registrationProps: Object,
    openMarketInfoProps: Object
  },

  data() {
    return {
      registration: {},
      openMarketInfo: {},
      itemDstrDiscount: {},
      tinsAmt: '0',
      hphnInitStlmAmt: '0',
      pricePerMonth: 0,
      agmtTermMmct: '24'
    }
  },

  mounted() {
    this.registration = this.registrationProps
    this.openMarketInfo = this.openMarketInfoProps
    this.tinsAmt = this.commaAmt(this.registration.tinsAmt)
    this.hphnInitStlmAmt = this.commaAmt(this.registration.hphnInitStlmAmt)
    if(this.registration.dcntKdCd === 'DT01') {
      this.agmtTermMmct = "24"
      this.pricePerMonth = this.commaAmt(
        (
          (this.registration.tinsAmt / (24 * 100)) *
          100
        ).toFixed()
      )
    }
    if(this.registration.dcntKdCd === "DT02") {
      this.agmtTermMmct = this.registration.agmtTermMmct
      this.pricePerMonth = this.commaAmt(
        (
          (this.registration.tinsAmt / (this.registration.agmtTermMmct * 100)) *
          100
        ).toFixed()
      )
    }
  },

  methods: {
    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button'
          }
        ]
      })
    },

    /** 
     * Function    : commaAmt
     * Description : 판매 금액 "," 넣기
     **/
    commaAmt(amt) {
      let amtData = amt ? amt : 0
      return common.comma(amtData)
    }
  }
}
</script>

<style scoped></style>
